import { render, staticRenderFns } from "./ShoppingNote.vue?vue&type=template&id=499b8760&scoped=true&"
import script from "./ShoppingNote.vue?vue&type=script&lang=js&"
export * from "./ShoppingNote.vue?vue&type=script&lang=js&"
import style0 from "./ShoppingNote.vue?vue&type=style&index=0&id=499b8760&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499b8760",
  null
  
)

export default component.exports